import React, { useEffect, useRef, useState } from "react";
import { cx } from "../lib/ui";

const HOLD_MS = 520;

export default function Preloader({ onDone }) {
  const [count, setCount] = useState(0);
  const [leaving, setLeaving] = useState(false);
  const finished = useRef(false);

  useEffect(() => {
    let raf = 0;
    let start = null;
    const duration = 1500;

    const tick = (now) => {
      if (start === null) start = now;
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3); // sprint, then settle
      setCount(Math.round(eased * 100));

      if (t < 1) {
        raf = window.requestAnimationFrame(tick);
      } else if (!finished.current) {
        finished.current = true;
        setLeaving(true);
        window.setTimeout(() => onDone && onDone(), HOLD_MS);
      }
    };

    raf = window.requestAnimationFrame(tick);
    return () => window.cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <div className="fixed inset-0 z-[9999] grid place-items-center bg-ink px-gutter" aria-hidden="true">
      <div
        className={cx(
          "w-[min(520px,100%)] transition-[opacity,transform] duration-500 ease-out",
          leaving ? "-translate-y-4 opacity-0" : "translate-y-0 opacity-100"
        )}
      >
        <img
          className="mx-auto mb-8 h-auto w-[min(360px,78%)] animate-logo-in [animation-delay:100ms]"
          src="/images/logo-white.png"
          alt=""
          width="360"
          height="92"
        />

        <div className="mb-3 flex items-baseline justify-between text-[11px] uppercase tracking-[0.24em] text-ash-400">
          <span>Ahmedabad · Gujarat</span>
          <span className="font-display text-[34px] leading-none tracking-[0.02em] text-paper tabular-nums">
            {String(count).padStart(3, "0")}
          </span>
        </div>

        <div className="h-px overflow-hidden bg-white/15">
          <i
            className="block h-full origin-left bg-paper"
            style={{ transform: `scaleX(${count / 100})` }}
          />
        </div>
      </div>

      {/* Exit: a white blade wipes up, then off the top. */}
      <div
        className={cx(
          "absolute inset-0 origin-bottom scale-y-0 bg-paper",
          leaving && "animate-wipe"
        )}
      />
    </div>
  );
}
